import { EmailPlusOutlineIcon } from './EmailPlusOutlineIcon';

/**
 * author: GreenTurtwig
 * id 156DF0DC-6BDA-4204-BDDB-5FA69911CDDB
 * name email-plus-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-plus-outline.svg
 * tags
 */
export const EmailAddOutlineIcon = EmailPlusOutlineIcon;
export default EmailAddOutlineIcon